import { useMutation } from "@apollo/client";
import { 
  CREATE_ESTABLISHMENT_MUTATION, 
  UPDATE_ESTABLISHMENT_MUTATION, 
  DELETE_ESTABLISHMENT_MUTATION,
} from "../graphQl/EstablishmentAPI";
import {
  GET_ADMIN_ESTABLISHMENTS,
  buildAdminEstablishmentsVariables,
} from "../../../hooks/AdminAPI";

export const useEstablishment = (organizationId = null) => { // On accepte l'ID ici
  const [createMutation, { loading: isCreating }] = useMutation(CREATE_ESTABLISHMENT_MUTATION);
  const [updateMutation, { loading: isUpdating }] = useMutation(UPDATE_ESTABLISHMENT_MUTATION);
  const [deleteMutation, { loading: isDeleting }] = useMutation(DELETE_ESTABLISHMENT_MUTATION);

  // Création / suppression : la liste centrale d'AdminProvider (source unique
  // pour toutes les pages de /admin, hors table paginée) est relue. Une
  // modification n'en a pas besoin : la réponse de MT_UPDATE_ESTABLISHMENT met
  // à jour l'entrée normalisée de l'établissement dans le cache. La table
  // paginée de /admin/establishments se relit d'elle-même : à l'affichage
  // (cache-and-network) et, après une suppression, via EstablishmentTable.
  const refetchConfig = organizationId ? {
    refetchQueries: [
      {
        query: GET_ADMIN_ESTABLISHMENTS,
        variables: buildAdminEstablishmentsVariables(organizationId),
      }
    ]
  } : {};

  
  const editEstablishment = async (establishmentId, establishmentInput) => {
    return await updateMutation({
      variables: { establishmentId, establishmentInput }
    });
  };

  const addEstablishment = async (establishmentInput) => {
    return await createMutation({
      variables: { establishmentInput },
      ...refetchConfig
    });
  };

  const removeEstablishment = async (establishmentId) => {
    return await deleteMutation({
      variables: { establishmentId },
      ...refetchConfig
    });
  };
  
  return {
    addEstablishment,
    editEstablishment,
    removeEstablishment,
    loading: isCreating || isUpdating || isDeleting
  };
};
